
import Vue from 'vue'
import jbUserTransformer from './../../transformers/jbUser'


export default (type) =>
  Vue.$http.get(`/user/type/${type}/`)
    .then((response) => {
      let data = jbUserTransformer.fetchCollection(response.data)
      return data.sort((a,b) => a.name < b.name ? -1 : 1)
    })


// WEBPACK FOOTER //
// ./src/services/user/fetchType.js